import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import { SectionData } from '@/types/home';
import { useRouter } from 'next/router';

const GeneralExampDownloadContent = ({ data }: { data?: SectionData }) => {
  const router = useRouter();

  const getContent = () => {
    return data ? (
      <div className={styles.content}>
        {data?.title && <h2 className={styles.title}>{data?.title}</h2>}

        {data?.desc && <p className={styles.desc}>{data?.desc}</p>}

        <div className={styles.contentList}>
          {data?.cards?.length > 0 &&
            data?.cards?.map((item, index) => (
              <div className={styles.contentItem} key={index}>
                <div className={styles.contentItemTopContainer}>
                  <div className={classNames(styles.contentItemTitle)}>
                    <Image src={item.imgPath} alt={''} width={28} height={28} />
                    <h3 className={styles.subTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.subDesc}>{item.desc}</p>
                </div>

                {item?.btnTitle && (
                  <div>
                    <span
                      className={styles.linkContainer}
                      onClick={() => {
                        item?.btnLink && router?.push(item?.btnLink);
                      }}
                    >
                      {item?.btnTitle}
                      <Image src={'/images/landingpage/arrow-icon1.webp'} alt={''} width={24} height={24} />
                    </span>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    ) : null;
  };

  return <>{getContent()}</>;
};

export default GeneralExampDownloadContent;
